import Class from './c-content';
import './c-content@';
import './c-content.scss';

export default Class;